import {urlJoin} from '@practicegenius/pg-util/src/UrlUtils';
import {inferServiceBrandFromWindow} from '@practicegenius/domain/src/data/serviceBrand';
import {FILES_URL} from '../constants/env';

export const GENERIC_HUB = 'hub';

export function getPracticeHubName(): string | undefined {
  if (typeof window === 'undefined') return inferServiceBrandFromWindow();

  const [subdomain] = window.location.host.split('.');
  return subdomain;
}

export const getLogoUrl = (filename: string): string =>
  urlJoin(FILES_URL, 'identity', filename);

export const isGenericHub = getPracticeHubName() === GENERIC_HUB;
